// extracted by mini-css-extract-plugin
module.exports = {"description":"_1yvxJ","infoSectionCollapse":"_2knBS","button":"_2K_N3","icon":"_2tV5m"};